import { render, staticRenderFns } from "./CompanionOverview.vue?vue&type=template&id=79668b18&"
import script from "./CompanionOverview.vue?vue&type=script&lang=js&"
export * from "./CompanionOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports